import CurrentTeamBox from './CurrentTeamBox';

export default CurrentTeamBox;
